<script>
    import Skills from "./sections/Skills.svelte";
    import Experience from "./sections/Experience.svelte";
    import Education from "./sections/Education.svelte";

    const resumeSections = [
        {cmp: Experience, title: 'EXPERIENCE'},
        {cmp: Skills, title: 'SKILLS'},
        {cmp: Education, title: 'EDUCATION'}
    ]
</script>
<!--------------------------------------------------------------------------------------------------------------------->

<article class="resume">
    {#each resumeSections as section}
        <section>
            <h2>{section.title}</h2>
            <svelte:component this={section.cmp} />
        </section>
    {/each}
</article>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .resume {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        flex-grow: 1;
    }
    section {
        display: flex;
        padding-bottom: 30px;
        padding-top: 10px;
    }

    h2 {
        min-width: 220px;
    }
    /*=======================================================================================*/
    /*==================================     MEDIA     ======================================*/

    @media screen and (max-width: 500px) {
        section {
            flex-direction: column;
            border-bottom: 1px solid var(--dark-grey);
        }
        h2 {
            padding-bottom: 2rem;
        }
    }
</style>
